export default __webpack_public_path__ + "static/404-447467e5eb2932657e9b42a5ac6982c3.svg";